import React, { useEffect, useState } from 'react'

import { UserChoicesAndWrongs } from 'store/userChoicesAndWrongsGroup'
import useExamInform from '@hooks/useExamInform'
import useViewResultModeStore from 'store/viewResultMode'

import Choice, { ChoiceProps, ChoiceCompProps } from './Choice'

type ChoicesProps = {
  questionNumber: number
  choices: ChoiceProps[]
  isDelivery?: boolean
}

const Choices: React.FC<ChoicesProps> = ({ questionNumber, choices, isDelivery }) => {
  const {
    currentQuestionGroup,
    userChoicesAndWrongsGroup,
    updateQuestionChoiceOfCurrentGroup,
    updateQuestionWrongsOfCurrentGroup,
    getAnswerResultByQuestionNumber,
  } = useExamInform(isDelivery)

  const [currentQA, setCurrentQA] = useState<UserChoicesAndWrongs>({})
  const selectedChoiceNumber = currentQA ? currentQA[questionNumber]?.choice : undefined
  const currentWrongChoices = currentQA ? currentQA[questionNumber]?.wrong || [] : []

  const { viewResultMode } = useViewResultModeStore()
  const [answer, setAnswer] = useState('')

  useEffect(() => {
    const getQA = async () => {
      const group = userChoicesAndWrongsGroup[currentQuestionGroup.id || 0]
      if (currentQuestionGroup.id && group) setCurrentQA(group)
    }
    getQA()
  }, [userChoicesAndWrongsGroup, currentQuestionGroup])

  useEffect(() => {
    if (viewResultMode) {
      const answerResult = getAnswerResultByQuestionNumber(questionNumber)
      setAnswer(answerResult?.answer ? answerResult.answer.toString() : '')
    }
  }, [viewResultMode, questionNumber, getAnswerResultByQuestionNumber])

  const setChoice = (choice: number) => {
    updateQuestionChoiceOfCurrentGroup(questionNumber, choice)
  }

  const isWrong = (choice: number) => currentWrongChoices?.includes(choice)

  const setWrong = (choice: number) => {
    if (isWrong(choice)) {
      const wrongChoices = currentWrongChoices.filter((wc) => {
        return wc !== choice
      })
      updateQuestionWrongsOfCurrentGroup(questionNumber, wrongChoices)
    } else {
      updateQuestionWrongsOfCurrentGroup(questionNumber, [...currentWrongChoices, choice])
    }
  }

  return (
    <div className={'mt-6 sm:mt-9'}>
      {choices &&
        choices
          .sort((a, b) => +a.number - +b.number)
          .map((choice) => {
            const choiceProps: ChoiceCompProps = {
              questionNumber,
              choice,
              setChoice,
              selectedChoiceNumber,
              setWrong,
              isWrong: isWrong(choice.number),
              isAnswer: viewResultMode ? String(choice.number) === answer : false,
            }
            return <Choice key={choice.number} {...choiceProps} />
          })}
    </div>
  )
}

export default Choices
